import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { styled } from "@mui/material/styles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.error[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const AttestationLoginForm = () => {
  const [open, setOpen] = React.useState(false);
  const [otp, setOtp] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOtp = () => {
    setOtp(true);
  };
  const handleCloseOtp = () => {
    setOtp(false);
  };

  return (
    <>
      <div className="outer-wrapper">
        <div className="inner-wrapper  items-center ">
          <div className="bg-[#efefef] flex flex-col justify-center items-center min-h-[180px] py-[2rem] ">
            <h1 className="text-[30px] sm:text-[40px] font-bold ">Login</h1>
          </div>
        </div>
      </div>

      <div className="outer-wrapper my-[3rem]">
        <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">
          <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem] leading-5">Login Here</h2>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col ">
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative w-[24rem]">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Email
                      </label>
                    </div>
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative w-[24rem]">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Password
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[49rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
              login
            </button>
            <div className="grid justify-center items-center mb-3">
              <a
                onClick={handleClickOpen}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#F21E26] font-bold flex justify-center pt-[.5rem]"
              >
                Forget Password
              </a>
              <hr className="react-reveal my-[1rem] w-[20rem] " />
              <div className="centered_link">
                Don't Have account?{" "}
                <a
                  onClick={handleClickOtp}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-[#F21E26] font-bold"
                >
                  Create new account
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ForgetPassword Modal */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="modalshadow"
        id="modalshadow"
      >
        <div className="flex justify-center forgot-password">
          {/* <div className="pb-[1rem] forgot-password"> */}
          <img
            src="/nrp-icons/forget-password.png"
            alt=""
            className=""
            width="40%"
          />
          {/* </div> */}
        </div>
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        ></BootstrapDialogTitle>
        {/* <DialogContent> */}
        <div className="relative top-[-25px]">
          <div className="flex items-start">
            <div className="flex flex-col justify-center items-center w-[60rem] leadership-card">
              <h1 className="font-bold font text-3xl">Forget Password</h1>
            </div>
          </div>
          <div className="grid justify-center mt-[1rem]">
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="relative w-[24rem]">
                <input
                  type="text"
                  id="floating_outlined"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                />
                <label
                  for="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Enter Your Email
                </label>
              </div>
            </div>

            <button className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[24rem] mt-[1rem] mb-[1rem] rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
              Submit
            </button>
          </div>
        </div>
        {/* </DialogContent> */}
      </BootstrapDialog>
      {/* ForgetPassword Modal */}

      {/*OTP Verification Modal */}
      <BootstrapDialog
        onClose={handleCloseOtp}
        aria-labelledby="customized-dialog-title"
        open={otp}
        className="modalshadow"
        id="modalshadow"
      >
        <div className="flex justify-center forgot-password">
          {/* <div className="pb-[1rem] forgot-password"> */}
          <img
            src="/nrp-icons/otp-verification.png"
            alt=""
            className=""
            width="40%"
          />
          {/* </div> */}
        </div>
        <BootstrapDialogTitle
          id="customized-dialog-title0"
          onClose={handleCloseOtp}
        ></BootstrapDialogTitle>
        {/* <DialogContent> */}
        <div className="relative top-[-25px]">
          <div className="flex items-start">
            <div className="flex flex-col justify-center items-center w-[60rem] leadership-card">
              <h1 className="font-bold font text-3xl">OTP Verification</h1>
              <p>
                Enter OTP Code sent to{" "}
                <span className="text-red-600">abc@gmail.com</span>
              </p>
              <div className="sm:flex grid gap-6">
                <div className="flex MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative w-[3rem] mr-[.3rem]">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      1
                    </label>
                  </div>
                  <div className="relative w-[3rem] mr-[.3rem]">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      2
                    </label>
                  </div>
                  <div className="relative w-[3rem] mr-[.3rem]">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      3
                    </label>
                  </div>
                  <div className="relative w-[3rem] mr-[.3rem]">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    ></label>
                  </div>
                  <div className="relative w-[3rem] mr-[.3rem]">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    ></label>
                  </div>
                  <div className="relative w-[3rem] ">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    ></label>
                  </div>
                </div>
              </div>
              <p>Didn't receive OTP code?</p>
              <a
                href="#"
                className="text-[#D40511] underline font-bold  hover:text-[#D40511]"
              >
                Resend Code
              </a>
              <button className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[24rem] mt-[1rem] mb-[2rem] rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
                Verify and Proceed
              </button>
            </div>
          </div>
        </div>
      </BootstrapDialog>
      {/* OTP Verification Modal */}
    </>
  );
};
export default AttestationLoginForm;
